export var trendModel = [
    {
        id: "increasing",
        label: "2f_text_93",
        icon: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/2f_image_10/path-22x.png",
        overlay: require("@/assets/images/otolith/trend-shape-increase.png"),
        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/sonification-trend-increasing/sonified-trend-ascending.wav",
    },
    {
        id: "increasingSteady",
        label: "2f_text_94",
        icon: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/2f_image_11/trend-line-increas-level2x.png",
        overlay: require("@/assets/images/otolith/trend-shape-increase-level.png"),
        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/sonification-trend-increasing-level/sonified-trend-asc-stable.wav",
    },
    {
        id: "steady",
        label: "2f_text_95",
        icon: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/2f_image_12/path-52x.png",
        overlay: require("@/assets/images/otolith/trend-shape-steady.png"),
        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/sonification-trend-steady/steady-real.wav",
    },
    {
        id: "decreasing",
        label: "2f_text_96",
        icon: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/2f_image_13/path-22x.png",
        overlay: require("@/assets/images/otolith/trend-shape-decrease.png"),
        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/sonification-trend-decreasing/sonified-trend-descending.wav",
    },
    {
        id: "decreasingSteady",
        label: "2f_text_97",
        icon: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/2f_image_14/trend-line-decrease-level2x.png",
        overlay: require("@/assets/images/otolith/trend-shape-decrease-level.png"),
        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/sonification-trend-decreasing-level/sonified-trend-desc-stable.wav",
    },
    {
        id: "increasingDecreasing",
        label: "2f_text_98",
        icon: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/2f_image_15/stroke-32x.png",
        overlay: require("@/assets/images/otolith/trend-shape-increase-decrease.png"),
        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/sonification-trend-increasing-decreasing/sonified-trend-asc-desc.wav",
    },
]